import React from 'react';
import ProjectShowcase from './components/ProjectShowcase';
import Navigation from './components/Navigation';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main className="main-content">
        <ProjectShowcase />
      </main>
    </div>
  );
}

export default App;
